import { render, staticRenderFns } from "./consultant-main.vue?vue&type=template&id=73b8da58"
import script from "./consultant-main.vue?vue&type=script&lang=js"
export * from "./consultant-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports